import { IConnectionDetailsDTO } from '../../../../../../../api/connections.dao';
import { IPhoneNumbersSet } from '../../../../../../../api/zoom.dao';
import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { AbstractFormViewModelController } from '../../../../../../../infrastructure/implementations/form-viewmodel-controller';
import { AudioBridgeConfigurationPresentation } from './audio-bridge-configuration-presentation';
import { AudioBridgeConfigurationVM, IAudioBridgeValues } from './audio-bridge-configuration.viewmodel';

export type IProps = {
  formVM: AbstractFormViewModelController;
  connection: IConnectionDetailsDTO;
  phoneNumbersSet: IPhoneNumbersSet[];
  isConnectionGroup: boolean;
  audioBridgeValues?: IAudioBridgeValues;
};

export const AudioBridgeConfigurationForm = withViewModel(AudioBridgeConfigurationPresentation, (props: IProps) => {
    const { formVM, connection, phoneNumbersSet, isConnectionGroup, audioBridgeValues } = props;
    return new AudioBridgeConfigurationVM(formVM, connection, phoneNumbersSet, isConnectionGroup, audioBridgeValues
  );
});